import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'clicks',
        label: t('search.overview.summary_chart.clicks'),
        icon: 'clicks',
        yAxisID: 'y3',
    },
    {
        key: 'impressions',
        label: t('search.overview.summary_chart.impressions'),
        icon: 'search',
    },
    {
        key: 'position',
        label: t('search.overview.summary_chart.position'),
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
    {
        key: 'ctr',
        label: t('search.overview.summary_chart.ctr'),
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
    },
    {
        key: 'keywords',
        label: t('search.overview.summary_chart.keywords'),
        yAxisID: 'y4',
        icon: 'pagev-view',
    },
    {
        key: 'urls',
        label: t('search.overview.summary_chart.urls'),
        yAxisID: 'y5',
        icon: 'pagev-view',
    },
];

export default keys;
